import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';

const namespaces = [
  'common',
  'client',
  'contact',
  'order',
  'comment',
  'cargo',
  'selected',
  'trip',
  'transport',
  'invoice',
  'user',
  'favorite',
  'km-cost',
  'transport-mileage',
  'wh-task',
  'insights',
  'additional-cost',
  'overdue',
  'future-payments',
];

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    ns: namespaces,
    defaultNS: 'common',
    lng: 'en', // if you're using a language detector, do not define the lng option
    fallbackLng: 'en',
    supportedLngs: ['en'],
    returnNull: false,
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });
